import React from "react";

const publications = [
  {
    type: "Paper",
    title:
      "Impact of Instructor Gender on Student Perceptions of Coding Demonstration Videos",
    venue: "ITiCSE 2026 - Paper",
    authors:
      "Deepti Gorrepati, Nevin Ada Çakmak, Yuseon Jeong, Zuhal Olomi and Brian Harrington",
    description: "",
    links: {
      paper: "#",
      slides: "#",
      code: "#",
    },
  },
  {
    type: "Poster",
    title: "Mapping Research on Student Self-Efficacy in Computer Science",
    venue: "ITiCSE 2026 Poster Track",
    authors:
      "Nevin Ada Çakmak, Zuhal Olomi, Arina Azmi, Deepti Gorrepati, Luoyuan Gu, Yuseon Jeong, Maria Motallebi, Kayna Mufidah, Zupaash Naveed, Krushal Rawat, Nihar Samant, Ishika Vithani and Brian Harrington",
    description: "",
    links: {
      poster: "#",
    },
  },
  {
    type: "Poster",
    title:
      "A Systematic Literature Mapping of Gender Bias Towards Instructors in Computer Science Education",
    venue: "ITiCSE 2026 Poster Track",
    authors:
      "Zuhal Olomi, Yuseon Jeong, Nevin Ada Çakmak, Deepti Gorrepati and Brian Harrington",
    description: "",
    links: {
      poster: "#",
    },
  },
];
function Publications() {
  return (
    <div id="publications">
      <h1>Publications</h1>

      <div className="projects-container">
        {publications.map((pub, index) => (
          <div className="project-card" key={index}>
            <div className="project-content">
              <h3>{pub.title}</h3>

              <p>
                <strong>{pub.type}</strong> • {pub.venue}
              </p>

              <p>{pub.authors}</p>

              <p>{pub.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Publications;
